import { IComponentOptions } from "angular";
import { SingleMachineWarehouseComponentController } from "./controller";

export const vsComponentName = "machineWarehouse";
export const singleMachineWarehouseComponentOptions: IComponentOptions = {
  controller: SingleMachineWarehouseComponentController,
  controllerAs: "singleMachineWarehouseComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
  },
};
